import { ReactNode, useState } from 'react'
import Sidebar from '../components/sidebar/SideBar';
import { useFailedOrdersNotice } from '../hooks/useFailedOrdersNotice';
import Alert, { AlertType } from '../components/alert/Alert';
import { useNavigate } from "react-router";
import { useTranslation } from 'react-i18next';

interface DashboardLayoutProps {
  children: ReactNode;
}

export default function DashboardLayout({ children }: DashboardLayoutProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [alertMsgs, setAlertMessages] = useState<Partial<Record<string, string[]>>>({});

  useFailedOrdersNotice(setAlertMessages);

  const viewOrders = () => {
    setAlertMessages({});
    navigate('/orders', { state: { status: 'failed' } });
  }

  return (
    <div className="flex  w-screen ">
      {alertMsgs.messages && (
        <div className='absolute z-50 top-4 right-4'>
          <Alert
            type={AlertType.error}
            onClose={() => setAlertMessages({})}
          >
            <div className="flex items-center gap-2">
              <p className="text-primary-dark font-sans text-[14px] font-normal">
                {alertMsgs.messages}
              </p>
              <button
                className="text-error-dark font-sans text-[14px] font-medium"
                onClick={viewOrders}
              >
                {t("view-orders")}
              </button>
            </div>
          </Alert>
        </div >
      )}

      <Sidebar />
      <main className="flex-1 min-h-screen bg-white">
        {children}
      </main>
    </div >
  )
}